import React, { useState, useEffect } from 'react';
import { Box, Flex, Button, SelectDropdown, Typography } from '@kistech/kis-ui';
import { CreateKioskTicketTemplatePayload } from 'store/kioskTicketTemplates';
import { getKioskTicketTemplateInitialForm } from '../../utils';
import { Grid, Typography as MuiTypography, Box as MuiBox } from '@mui/material';
import { useStyles } from '../../styled';
import { ConfigCreateFormProps } from '../../types';
import { selectors as ticketTemplatesSelectors, TicketTemplate } from 'store/ticketTemplates';
import { getSortedList } from 'utils/stringFormat';
import { useSelector } from 'react-redux';

export const CreateKioskTicketTemplateForm = (props: ConfigCreateFormProps) => {
  const { kiosk, loading, error, onSubmit } = props;
  const classes = useStyles()();

  const ticketTemplates = useSelector(ticketTemplatesSelectors.selectTicketTemplates);

  const [selectedTicketTemplate, setSelectedTicketTemplate] = useState<TicketTemplate | null>(null);

  // SETS THE FORM VALUES AND VALIDATION VALUES FOR EACH FORM VALUE (INVALID | VALID)
  const initialForm = getKioskTicketTemplateInitialForm();
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (kiosk) {
      setForm({ ...form, kioskId: kiosk.id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // FORM SUBMIT FOR CREATION
  const onCreateClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const payload: CreateKioskTicketTemplatePayload = {
      kioskId: form.kioskId,
      ticketTemplateId: form.ticketTemplateId
    };

    onSubmit(payload);
  };

  // CONDITIONS FOR DISABLING SUBMIT BUTTON
  const buttonDisabled = !selectedTicketTemplate;

  // for hardware selection
  const onTicketTemplateChange = (item: TicketTemplate) => {
    setSelectedTicketTemplate(item);
    setForm({ ...form, ticketTemplateId: item.id });
  };

  return (
    <Flex justify="center" flexOverride="1 1 0%" padding="0 0 11">
      <Flex direction="column" fullWidth align="center" justify="center">
        <Grid className={classes.createClientInnerContainer}>
          <Box flexOverride="none" fullWidth margin="0 0 4">
            <MuiTypography className={classes.createNewClientHeading}>Create New Kiosk Ticket Template</MuiTypography>
          </Box>
          <Flex fullWidth direction="row" margin="4 0 4 6" align="center">
            <Typography size={16} weight={600} style={{ padding: '0 0 0 24px' }}>
              Kiosk
            </Typography>
            <Box width={107} />
            <Typography size={16} weight={600} style={{ padding: '0 0 0 24px' }}>
              {kiosk && kiosk.name}
            </Typography>
          </Flex>
          <Flex fullWidth direction="row" margin="4 0 4 6" align="center">
            <Typography size={16} weight={600} style={{ padding: '0 0 0 24px' }}>
              TicketTemplate
            </Typography>
            <Box width={30} />
            <Box width={200}>
              <SelectDropdown
                placeholder="Select a TicketTemplate"
                items={getSortedList(ticketTemplates, 'id')}
                selectedItem={selectedTicketTemplate as TicketTemplate}
                onChange={(item: TicketTemplate) => onTicketTemplateChange(item)}
                itemToString={(item: TicketTemplate) => (item ? `${item.id} (${item.type})` : '')}
              />
            </Box>
          </Flex>
        </Grid>

        {error && <MuiTypography className={classes.createClientErrorText}>{error}</MuiTypography>}

        {/* FORM SUBMIT */}
        <MuiBox className={classes.createClientButtonBox}>
          <Button
            isDisabled={buttonDisabled}
            size="medium"
            onClick={onCreateClick}
            isLoading={loading}
            width={334}
            type="submit"
            className={classes.createClientButton}
          >
            Create Kiosk Ticket Template
          </Button>
        </MuiBox>
      </Flex>
    </Flex>
  );
};
